
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class SalaryComponentGrid extends _Ext.GridBase<SalaryComponentRow, any> {
        protected getColumnsKey() { return 'HR.SalaryComponent'; }
        protected getDialogType() { return SalaryComponentDialog; }
        protected getIdProperty() { return SalaryComponentRow.idProperty; }
        protected getInsertPermission() { return SalaryComponentRow.insertPermission; }
        protected getLocalTextPrefix() { return SalaryComponentRow.localTextPrefix; }
        protected getService() { return SalaryComponentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}